import { CampaignStatus } from 'common/types/models/campaign';

export enum CampaignsColors {
    Yellow = 'yellow',
    Blue = 'blue',
    Purple = 'purple',
    Red = 'red',
    Green = 'green',
}

export const CampaignStatusTitle = {
    [CampaignStatus.Pending]: 'Pending Campaign',
    [CampaignStatus.Hold]: 'On Hold',
    [CampaignStatus.Active]: 'Pitching to Curators',
    [CampaignStatus.Canceled]: 'Denied',
    [CampaignStatus.Approved]: 'Approved',
    [CampaignStatus.Completed]: 'Placement Completed',
    [CampaignStatus.Refunded]: 'Order Refunded',
    [CampaignStatus.Disputed]: 'Order Disputed',
};

export const CampaignStatusColor = {
    [CampaignStatus.Pending]: CampaignsColors.Purple,

    [CampaignStatus.Hold]: CampaignsColors.Blue,
    [CampaignStatus.Active]: CampaignsColors.Blue,

    [CampaignStatus.Canceled]: CampaignsColors.Red,
    [CampaignStatus.Refunded]: CampaignsColors.Red,

    [CampaignStatus.Approved]: CampaignsColors.Green,
    [CampaignStatus.Completed]: CampaignsColors.Green,

    [CampaignStatus.Disputed]: CampaignsColors.Yellow,
};
